(function () {
  document.querySelectorAll('.ss-block').forEach(initBuyBox);

  function initBuyBox(root) {
    const tiersEl = root.querySelector('.ss-tiers');
    const blockId = tiersEl ? tiersEl.dataset.blockId : null;

    const tiers = Array.from(root.querySelectorAll('.ss-tier'));
    const cadenceButtons = Array.from(root.querySelectorAll('.ss-cadence-btn'));
    const qtyInput = root.querySelector(`#ss-qty-input-${blockId}`);
    const sellingPlanInput = root.querySelector(`#ss-selling-plan-input-${blockId}`);

    const isSubscriptionEnabled = root.dataset.enableSubscription !== 'false' && cadenceButtons.length > 0;
    let mode = isSubscriptionEnabled ? 'subscribe' : 'onetime';

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function renderTier(tier) {
      const qty = parseFloat(tier.dataset.qty);
      const unitPrice = parseFloat(tier.dataset.unitPrice);
      const subDiscount = parseFloat(tier.dataset.subDiscount) || 0;
      const onetimeDiscount = parseFloat(tier.dataset.onetimeDiscount) || 0;
      const fullTotal = unitPrice * qty;

      const discount = mode === 'subscribe' ? subDiscount : onetimeDiscount;
      const discountedTotal = fullTotal * (1 - discount / 100);
      const perPack = discountedTotal / qty;

      const perPackEl = tier.querySelector('[data-role="per-pack"]');
      const strikeEl = tier.querySelector('[data-role="strike"]');
      const offEl = tier.querySelector('[data-role="off"]');

      perPackEl.textContent = formatMoney(perPack) + '/pack';

      if (discount > 0) {
        strikeEl.textContent = formatMoney(unitPrice);
        offEl.textContent = discount + '% off';
        strikeEl.style.display = '';
        offEl.style.display = '';
      } else {
        strikeEl.style.display = 'none';
        offEl.style.display = 'none';
      }
    }

    function renderAll() {
      tiers.forEach(renderTier);
    }

    function updateSellingPlanInput(tier) {
      if (!sellingPlanInput) return;
      if (isSubscriptionEnabled && mode === 'subscribe' && tier && tier.dataset.sellingPlanId) {
        sellingPlanInput.value = tier.dataset.sellingPlanId;
        sellingPlanInput.disabled = false;
      } else {
        sellingPlanInput.value = '';
        sellingPlanInput.disabled = true;
      }
    }

    function selectTier(tier) {
      tiers.forEach((t) => t.classList.remove('is-selected'));
      tier.classList.add('is-selected');
      const radio = tier.querySelector('input[type="radio"]');
      radio.checked = true;
      if (qtyInput) qtyInput.value = tier.dataset.qty;
      updateSellingPlanInput(tier);
    }

    tiers.forEach((tier) => {
      tier.addEventListener('click', () => selectTier(tier));
    });

    cadenceButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        cadenceButtons.forEach((b) => {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        mode = btn.dataset.mode;

        const selected = tiers.find((t) => t.classList.contains('is-selected'));
        if (selected) updateSellingPlanInput(selected);

        renderAll();
      });
    });

    // Sync BOTH quantity and selling_plan to match whichever tier is
    // pre-selected on load — not just the selling plan. Without this,
    // the hidden quantity input stays at its literal HTML default (1)
    // even when a different tier is visually pre-selected, until the
    // person manually clicks a tier.
    const initialTier = tiers.find((t) => t.classList.contains('is-selected'));
    if (initialTier) {
      if (qtyInput) qtyInput.value = initialTier.dataset.qty;
      updateSellingPlanInput(initialTier);
    }

    renderAll();
  }
})();